import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Subject, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

// interface SignInForm {
//   email: FormControl<string>;
//   password: FormControl<string>;
// }

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class SignInComponent {
  private authService = inject(AuthService);

  /*public emailPasswordForm = new FormGroup<SignInForm>({
    email: new FormControl('', {
      nonNullable: true,
      validators: [
        Validators.required,
        Validators.email,
        Validators.maxLength(150),
      ],
    }),
    password: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });*/

  //public hidePassword = true;

  //public emailPasswordFormSubmit = new Subject<void>();

  /*public emailPasswordResponse$ = this.emailPasswordFormSubmit.pipe(
    switchMap(() =>
      this.authService.signInWithEmailAndPassword(
        this.emailPasswordForm.controls.email.value.trim(),
        this.emailPasswordForm.controls.password.value,
      ),
    ),
  );*/

  public googleClick = new Subject<void>();

  public googleResponse$ = this.googleClick.pipe(
    switchMap(() => this.authService.signInWithGoogle()),
  );
}
